import { JobUserStatusEnum } from '@/types/jobUserStatus';

export function getStatusName(statusId: number): string {
  if(statusId == null)
    return "Assigned";
  if(statusId === JobUserStatusEnum.TRAVEL)
    return "Travel";
  if(statusId === JobUserStatusEnum.START_CONTINUE_WORK)
    return "Start/Continue Work";
  if(statusId === JobUserStatusEnum.BREAK)
    return "Break";
  if(statusId === JobUserStatusEnum.DAY_COMPLETE)
    return "Day Complete";
  if(statusId === JobUserStatusEnum.FINISH_WORK)
    return "Finished Work";
  if (statusId === JobUserStatusEnum.NONE_CHARGEABLE)
    return "Non-Chargeable";
  return "";
}

export function getStatusColor(statusId: number): string {
  if(statusId == null){
    return "error";
  }

  if(statusId === JobUserStatusEnum.START_CONTINUE_WORK
    || statusId === JobUserStatusEnum.TRAVEL){
    return "warning";
  }

  if(statusId === JobUserStatusEnum.FINISH_WORK){
    return "success";
  }

  if (statusId === JobUserStatusEnum.NONE_CHARGEABLE) {
    return "info";
  }

  return "primary";
}